module.exports = __webpack_public_path__ + "img/10235684.227686ff.png";